export default __webpack_public_path__ + "static/media/github.067f80f3.svg";